
export function lowercase(value: string | null): string {
    if (value == null) {
        return '';
    }

    return value.toLowerCase();
}
